// extracted by mini-css-extract-plugin
export var actionText = "_qt-4";
export var container = "_qt-0";
export var leftSection = "_qt-1";
export var rightSection = "_qt-2";
export var settingsButton = "_qt-6";
export var settingsIcon = "_qt-7";
export var shortcut = "_qt-5";
export var shortcutGroup = "_qt-3";